// AdminEventsPage.jsx

import MembersListTable from "../components/users/MemberList";

import React, { useCallback, useEffect, useState } from "react";
import { getAllMembers } from "../../controller/c_member.js";

export default function AdminUsers() {

    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);


    // load data from the api services
    const loadMembers = useCallback(async () => {
        const memberslist = await getAllMembers();

        setMembers(memberslist || []);

        setLoading(false);

    }, []);

    // auto refresh every 10 seconds
    useEffect(() => {
        setLoading(true);

        loadMembers();
        const id = setInterval(() => {
            loadMembers();
        }, 10000);

        return () => {
            clearInterval(id);
        };
    }, [loadMembers]);


    return (
        <div className="text-light">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h1 className="h3 fw-bold mb-0">Members</h1>
            </div>


            <MembersListTable  membersProp={members} loading={loading}/>
            
        </div>
    );
}
